import clsx from 'clsx'
import {FC, PropsWithChildren, useEffect, useMemo} from 'react'
import {HeaderProps} from 'react-table'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {User} from '../../core/_models'
import { initialQueryState } from '../../../../../../_handld/helpers'

type Props = {
  className?: string
  title?: string
  tableProps: PropsWithChildren<HeaderProps<User>>
}
const UserCustomHeader: FC<Props> = ({className, title, tableProps}) => {
  const id = tableProps.column.id
  const { state, updateState } = useQueryRequest()

  const isSelectedForSorting = useMemo(() => {
    return state.sortField === id && state.sortOrder !== undefined
  }, [state, id])

  const sortColumn = () => {
    // Avoid sorting for these columns
    if (id === 'actions' || id === 'selection') {
      return
    }


    if (!isSelectedForSorting || state.sortOrder === 'desc') {
      // Enable sort asc
      updateState({ sortField: id, sortOrder: 'asc', ...initialQueryState })
    } else if (state.sortOrder === 'asc') {
      // Enable sort desc
      updateState({ sortField: id, sortOrder: 'desc', ...initialQueryState })
    } else {
      // Disable sort
      updateState({ sortField: undefined, sortOrder: undefined, ...initialQueryState })
    }
  }

  return (
    <th
      {...tableProps.column.getHeaderProps()}
      className={clsx(
        className,
        isSelectedForSorting && `table-sort-${state.sortOrder}`
      )}
      style={{ cursor: 'pointer' }}
      onClick={sortColumn}
    >
      {title}
    </th>
  )
}

export {UserCustomHeader}
